import { render } from "./IconBenefitsOptions.vue?vue&type=template&id=db2f8fe2"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__